import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { UnAuthGuard } from './shared/guards/unauth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [UnAuthGuard],
    loadChildren: () => import('./auth/auth.routes').then((c) => c.routes),
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    loadChildren: () => import('./admin/admin.routes').then((m) => m.routes),
  },
  {
    path: '**',
    redirectTo: 'admin/training',
  },
];
